import { Facebook, Instagram, Youtube } from "../common/BrandIcons";
import { BRAND } from "../../constants/site";

// Social links. Only entries with a real URL are shown, so visitors never hit
// a dead icon. To add Facebook or YouTube later, paste the full https:// URL
// into its href and it will appear automatically.
// - Instagram: handle is @styledby.Trinya.Marieee
// - Facebook: profile name "Trinya Rolling" (URL not confirmed yet)
// - Youtube: no channel provided yet
const SOCIALS = [
  { Icon: Instagram, href: "https://www.instagram.com/styledby.Trinya.Marieee/", label: "Instagram" },
  { Icon: Facebook, href: "", label: "Facebook" },
  { Icon: Youtube, href: "", label: "Youtube" },
].filter(({ href }) => href.startsWith("https://"));

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <p className="site-footer__brand">{BRAND}</p>

        {SOCIALS.length > 0 ? (
          <div className="site-footer__socials">
            {SOCIALS.map(({ Icon, href, label }) => (
              <a
                key={label}
                className="social-link"
                href={href}
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        ) : null}

        <p className="site-footer__meta">© 2026 {BRAND}. All rights reserved.</p>
      </div>
    </footer>
  );
}
